import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App';
import '@/index.css';

// Suppress source map warnings in development
if (import.meta.env.DEV) {
  const originalConsoleWarn = console.warn;
  console.warn = (...args) => {
    const message = args.join(' ');
    if (message.includes('Source map') || message.includes('source map')) {
      return;
    }
    originalConsoleWarn.apply(console, args);
  };
}

// Register service worker for PWA support (production only — avoids
// interfering with Vite HMR during development).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  // Track whether this tab already had a controlling SW. We only force a
  // reload when an *update* takes over — not on the very first install,
  // which previously interrupted first paint / asset loading.
  let refreshing = false;
  const hadController = Boolean(navigator.serviceWorker.controller);

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registered successfully:', registration.scope);

        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // hourly

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          console.log('[PWA] New Service Worker found, installing...');

          newWorker.addEventListener('statechange', () => {
            // Only auto-activate when there is already a controller (true update)
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              console.log('[PWA] New Service Worker installed, activating update');
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((error) => {
        console.log('[PWA] Service Worker registration failed:', error);
      });

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // First install: a controller appears for the first time — do NOT reload.
      // That reload was racing the initial CSS/JS load and could leave users
      // on an unstyled shell until a second visit.
      if (!hadController) {
        console.log('[PWA] Service Worker now controlling this page (first install)');
        return;
      }
      if (refreshing) return;
      refreshing = true;
      console.log('[PWA] Service Worker updated, reloading to pick up new assets...');
      window.location.reload();
    });
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
